'use client'

import Link from 'next/link'
import { useEffect, useState } from 'react'
import type { Locale } from '@/data/catalog'
import ApplyForm from './ApplyForm'

const TEXT = {
  en: {
    eyebrow: 'Apply Now',
    title: 'Start Your Japanese Learning Journey',
    lead: "Fill out the form below and we'll get back to you within 24 hours with your placement test and course options.",
    already: 'Already a student?',
    login: 'Login to student portal',
  },
  ja: {
    eyebrow: 'お申し込み',
    title: '日本語学習を始めましょう',
    lead: '下記のフォームにご記入ください。24時間以内にプレースメントテストとコースオプションをご連絡いたします。',
    already: 'すでに受講中ですか？',
    login: '学生ポータルにログイン',
  },
}

/** Standalone application page; the same form as the Apply modal. Supports ?course=<slug>. */
export function RegisterPageView({ locale }: { locale: Locale }) {
  const t = TEXT[locale]
  const [course, setCourse] = useState('')

  useEffect(() => {
    setCourse(new URLSearchParams(window.location.search).get('course') ?? '')
  }, [])

  return (
    <main className="min-h-screen w-full">
      <section className="section-padding border-b border-brand-cool-gray/60">
        <div className="section-container max-w-4xl text-center space-y-4">
          <p className="section-eyebrow section-eyebrow-centered">{t.eyebrow}</p>
          <h1 className="type-section-title">{t.title}</h1>
          <p className="type-section-lead mx-auto">{t.lead}</p>
          <p className="type-body text-muted">
            {t.already}{' '}
            <Link
              href={`/${locale}/login`}
              className="font-semibold text-brand-green hover:text-brand-green/80 transition-colors"
            >
              {t.login}
            </Link>
          </p>
        </div>
      </section>

      <section className="section-padding">
        <div className="section-container max-w-2xl">
          <div className="ncp-form-card">
            <ApplyForm locale={locale} initialCourse={course} />
          </div>
        </div>
      </section>
    </main>
  )
}
